import { Icon } from 'antd';
import * as React from 'react';

const AirplaneSvg = (props: any) => (
  // tslint:disable
  <svg {...props} viewBox="0 0 18 18" version="1.1">
    <title>Path</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M15.3911885,0.416445699 L11.3798872,4.16760395 L1.70044292,2.62025117 L0.89382256,3.37048282 L7.76099589,7.52020164 L3.74969464,11.2713599 L0,10.990023 L5.55914031,17.8827763 L5.82074691,13.8502812 L9.83204816,10.0991229 L12.7097208,18 L13.5163411,17.2497683 L13.4509395,6.72308051 L17.4622407,2.97192226 C18.1162573,2.36235904 18.1816589,1.28390104 17.6148446,0.580558873 L17.593044,0.557114134 C17.0480303,-0.122783299 16.045205,-0.193117516 15.3911885,0.416445699" id="Path" fill={props.color || '#ED3833'} fillRule="nonzero"></path>
    </g>
</svg>
);

const AirplaneIcon = props => (
  <Icon component={(innerProps) => {
    return AirplaneSvg(Object.assign({}, innerProps, props));
  }}></Icon>
);

export default AirplaneIcon;
